import { render, staticRenderFns } from "./message-inbox.vue?vue&type=template&id=e29a8eb0&"
import script from "./message-inbox.vue?vue&type=script&lang=js&"
export * from "./message-inbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports